/* Dutch (UTF-8) initialisation for the jQuery UI time picker plugin. */
/* Written by <http://trentrichardson.com/examples/timepicker/> */
jQuery(function($){
  $.timepicker.regional['nl'] = {
    timeOnlyTitle: 'Selecteer tijd',
    timeText: 'Tijd',
    hourText: 'Uur',
    minuteText: 'Minuut',
    secondText: 'Seconde',
    millisecText: 'Miliseconde',
    currentText: 'Nu',
    closeText: 'Sluiten',
    ampm: false
  };
  $.timepicker.setDefaults($.timepicker.regional['nl']);  
});